module.exports = __webpack_public_path__ + "static/media/QR_Code.d9c08d39.svg";